/**
 * CMS-typed fallback content for add-on sections.
 *
 * Keyed by API bundle identifier (matches the CMS `identifier` field).
 * Each entry conforms to `BookingAddOnContent` shape with nested
 * `BookingAddOnImage` children (Pattern B, cast via `as unknown as`).
 *
 * Runtime pricing fields (`addButtonPrice`, `addButtonPriceValue`) are
 * NOT part of this content — they come from the commerce store enrichment.
 *
 * Legacy exports (hairStylingSection, etc.) are preserved at the bottom
 * for the seeder, which still reads from the local typed content.
 */
import type { BookingAddOnContent } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

function nullImage() {
  return { assetId: '', alt: '', width: 0, height: 0, url: '' }
}

/**
 * Toggle button state labels for the hair-or-makeup option selector.
 *
 * Exported separately because `BookingAddOnContent` has no corresponding
 * fields yet — graduate to CMS fields once the content model is updated.
 */
export const hairMakeupOptionSelectedLabel = ''
export const hairMakeupOptionUnselectedLabel = ''

// ─── CMS-typed fallback by API bundle identifier ─────────────────────────

export const addOnContentFallbacks: Record<string, BookingAddOnContent> = {
  HAIR_OR_MAKEUP: {
    internalName: '',
    identifier: '',
    eyebrow: '',
    heading: '',
    body: '',
    images: [],
    badgeLabel: '',
    addButtonLabel: '',
    optionSelectedLabel: hairMakeupOptionSelectedLabel,
    optionUnselectedLabel: hairMakeupOptionUnselectedLabel,
    inspireLinkText: '',
    inspireLinkUrl: '',
    sceneLabel: '',
    beforeImage: nullImage(),
    afterImage: nullImage(),
    beforeAfterAlt: '',
    tags: ''
  } as unknown as BookingAddOnContent,

  HAIR: {
    internalName: '',
    identifier: '',
    eyebrow: '',
    heading: '',
    body: '',
    images: [],
    badgeLabel: '',
    addButtonLabel: '',
    inspireLinkText: '',
    inspireLinkUrl: '',
    sceneLabel: '',
    beforeImage: nullImage(),
    afterImage: nullImage(),
    beforeAfterAlt: '',
    tags: ''
  } as unknown as BookingAddOnContent,

  MAKEUP: {
    internalName: '',
    identifier: '',
    eyebrow: '',
    heading: '',
    body: '',
    images: [],
    badgeLabel: '',
    addButtonLabel: '',
    inspireLinkText: '',
    inspireLinkUrl: '',
    sceneLabel: '',
    beforeImage: nullImage(),
    afterImage: nullImage(),
    beforeAfterAlt: '',
    tags: ''
  } as unknown as BookingAddOnContent,

  ADDON_OUTDOOR: {
    internalName: '',
    identifier: '',
    eyebrow: '',
    heading: '',
    body: '',
    images: [],
    badgeLabel: '',
    addButtonLabel: '',
    inspireLinkText: '',
    inspireLinkUrl: '',
    sceneLabel: '',
    beforeImage: nullImage(),
    afterImage: nullImage(),
    beforeAfterAlt: '',
    tags: ''
  } as unknown as BookingAddOnContent,

  ADDITIONAL_POSE: {
    internalName: '',
    identifier: '',
    eyebrow: '',
    heading: '',
    body: '',
    images: [],
    badgeLabel: '',
    addButtonLabel: '',
    inspireLinkText: '',
    inspireLinkUrl: '',
    sceneLabel: '',
    beforeImage: nullImage(),
    afterImage: nullImage(),
    beforeAfterAlt: '',
    tags: ''
  } as unknown as BookingAddOnContent,

  BLACK_AND_WHITE: {
    internalName: '',
    identifier: '',
    eyebrow: '',
    heading: '',
    body: '',
    images: [],
    badgeLabel: '',
    addButtonLabel: '',
    inspireLinkText: '',
    inspireLinkUrl: '',
    sceneLabel: '',
    beforeImage: nullImage(),
    afterImage: nullImage(),
    beforeAfterAlt: '',
    tags: ''
  } as unknown as BookingAddOnContent
}
